import z from 'zod';

export const WorkspacesResponseSchema = z.array(
  z.object({
    companyId: z.number().or(z.null()),
    companyName: z.string().or(z.null()),
  }),
);

export const TokensSchema = z.object({
  access: z.string(),
  accessExpiresIn: z.number(),
  refresh: z.string(),
  refreshExpiresIn: z.number(),
});

export const CompaniesSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    brandsFiltration: z.boolean(),
    labelMatchingLogic: z.enum(['flexible', 'strict']),
  }),
);

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  brandsFiltration: z.boolean(),
  labelMatchingLogic: z.enum(['flexible', 'strict']),
});

export const BrandsFiltrationRequestSchema = z.object({
  brandsFiltration: z.boolean(),
  labelMatchingLogic: z.enum(['flexible', 'strict']),
});

export const CampaignsResponseSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
  }),
);

export const MediaPlansResponseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
  }),
);

export type MediaPlanType = z.infer<typeof MediaPlansResponseSchema>;
